import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import router from "./libs/router/";
import store from "./libs/stores/";
import App from "./App.vue";
import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
config.autoAddCss = false;
import {
  faUndo,
  faSignOutAlt,
  faUser,
  faPhoneAlt,
  faEnvelope,
  faHandshake,
  faCalendarAlt,
  faPen,
  faUtensils,
  faArrowLeft,
  faCheck,
  faTimes,
  faHandPointer,
  faSun,
  faArrowRight,
  faCalendarDay,
  faEye,
  faExclamationTriangle,
  faExclamationCircle,
  faNotesMedical,
  faUtensilSpoon,
  faPlusCircle,
  faUserClock,
  faHourglassEnd,
  faBookReader,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Toasted from "vue-toasted";

import "./libs/res/Styles/Bootstrap.scss";
import "./libs/res/Styles/Global.scss";
import "./libs/res/Scripts/Bootstrap.js";

import { Header, Footer } from "./components/layouts";
import {
  Loader,
  List,
  LoaderLogo,
  SaveButton,
  Alert,
} from "./components/commons";

library.add(
  faUndo,
  faExclamationCircle,
  faExclamationTriangle,
  faSignOutAlt,
  faUser,
  faPhoneAlt,
  faEnvelope,
  faHandshake,
  faCalendarAlt,
  faCalendarDay,
  faPen,
  faUtensils,
  faArrowLeft,
  faArrowRight,
  faCheck,
  faTimes,
  faHandPointer,
  faSun,
  faEye,
  faNotesMedical,
  faUtensilSpoon,
  faPlusCircle,
  faUserClock,
  faHourglassEnd,
  faBookReader
);
Vue.use(BootstrapVue);
dom.watch();
Vue.use(Toasted, { iconPack: "fontawesome" });

Vue.component("LoaderLogo", LoaderLogo);
Vue.component("Loader", Loader);
Vue.component("Header", Header);
Vue.component("Footer", Footer);
Vue.component("Loader", Loader);
Vue.component("List", List);
Vue.component("SaveButton", SaveButton);
Vue.component("Alert", Alert);
Vue.component("font-awesome-icon", FontAwesomeIcon);

//Aggiungo le icone personazlizzate
import { LogoCsaMed, LogoAzienda } from "./components/icons";
Vue.component("LogoCsaMed", LogoCsaMed);
Vue.component("LogoAzienda", LogoAzienda);

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
